export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const endPoint = {
  login: "user/login",
  postMethod: "Post",
  getMethod: "Get",
  register: "user/register",
  Transaction: "transaction",
  ForgotPass: "user/forgot-password",
  changepass: "user/change_password",
  editprofile: "user/profile",
};
